import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointListNameCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['name']
  > {}

export const ChargePointListNameCell = (
  props: ChargePointListNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
